import { brand } from "../config/brands";
import AsyncStorage from "@react-native-async-storage/async-storage";
import React, { useEffect, useRef, useState } from "react";
import { Button } from 'react-bootstrap';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { deleteMenuCategory, deleteProduct, editMenuCategory, findBusinessByPhoneNumber, getBusiness, getBusinessById, getProductsByCategory } from "../adapter/api";
import axios from "axios";
import { Dialog } from '@mui/material';
import { ApiUrlService } from "../api-library/api-services";
import Layout from "../component/Layout";
import "./Categories.css";
import "./Menu.css";
import { ArrowUpTrayIcon, EllipsisVerticalIcon, MinusCircleIcon, PencilIcon, PlusCircleIcon, PlusIcon, TrashIcon } from "@heroicons/react/24/outline";

const Products = () => {
  const menuRequest = useRef(0);
  const itemRequest = useRef(0);
  const [menuError, setMenuError] = useState('');
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [subCat, setSubCat] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [items, setItems] = useState([]);
  const [dropdownOpenId, setDropdownOpenId] = useState(null);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [addProductModalOpen, setAddProductModalOpen] = useState(false);
  const [editProductModal, setEditProductModal] = useState(false);
  const [category, setCategory] = useState();
  const [categoryName, setCategoryName] = useState("");
  const [priority, setPriority] = useState("");
  const [image, setImage] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [lastImage, setLastImage] = useState(null);
  const toggleDropdown = (id) => setDropdownOpenId(dropdownOpenId === id ? null : id);

  const [productName, setProductName] = useState("");
  const [price, setPrice] = useState("");
  const [description, setDescription] = useState("");
  const [stock, setStock]=useState()
  const [barcode, setBarcode]=useState()
  const [searchTerm, setSearchTerm] = useState('');
  const [discountPercentage, setDiscountPercentage]=useState()
  const [isFeatured, setIsFeatured] = useState(false);
  const [discount, setDiscount] = useState(false);
  const [outOfStock, setOutOfStock] = useState(false);
  const [productImage, setProductImage] = useState("");
  const [productLastImage, setProductLastImage] = useState(null);

  const apiUrlService = new ApiUrlService();
  const getMenu = async () => {
    setLoading(true);
    try {
      const response = await getBusiness();

      const customerList = response.data.data.map(item => ({
        label: item.name,
        value: item.restaurant_id
      }));

      setCustomers(customerList);
      if (customerList.length) await getRestaurantMenuByBusiness(customerList[0].value);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching businesses", error);
      setLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

    // Derived states
    const filteredOrders = items.filter((order) => {
      const search = searchTerm.toLowerCase();
      return (
        order.name?.toLowerCase().includes(search)
      );
    });

  const getRestaurantMenuByBusiness = async (businessId) => {
    const request = ++menuRequest.current;
    ++itemRequest.current;
    setSelectedBusiness(businessId);
    setSelectedProduct(null); setItems([]); setProducts([]); setSubCat([]);
    setSearchTerm(''); setDropdownOpenId(null); setMenuError('');
    if (!businessId) { setLoading(false); return; }
    setLoading(true);
    try {
      const response = await getBusinessById(businessId);
      if (request !== menuRequest.current) return;
      const categories = response?.data?.data?.menuCategories;
      if (!Array.isArray(categories)) throw new Error('Invalid menu');
      setProducts(categories); setSubCat(categories);
      const first = categories[0];
      setSelectedProduct(first || null);
      if (first) {
        const itemVersion = ++itemRequest.current;
        const result = await getProductsByCategory(first.menuCatId);
        if (request !== menuRequest.current || itemVersion !== itemRequest.current) return;
        if (!Array.isArray(result?.data?.data)) throw new Error('Invalid products');
        setItems(result.data.data);
      }
    } catch {
      if (request === menuRequest.current) setMenuError('Could not load this menu. Select the business again to retry.');
    } finally { if (request === menuRequest.current) setLoading(false); }
  };
  const getRestaurantMenu = event => getRestaurantMenuByBusiness(event.target.value);
  const getRestaurantMenuCustom = id => getRestaurantMenuByBusiness(id);

  const openModal = (order) => {
    toggleDropdown(null)
    setSelectedOrder(order);
    setSelectedOrder(order); // Set the selected order to display its details
    setEditProductModal(true);
  };

  const getSubCategoryProductsCustom = async (id) => {
    const request = ++itemRequest.current;
    setItems([]); setLoading(true); setMenuError('');
    try {
      const response = await getProductsByCategory(id);
      if (request !== itemRequest.current) return;
      if (!Array.isArray(response?.data?.data)) throw new Error('Invalid products');
      setItems(response.data.data);
    } catch { if (request === itemRequest.current) setMenuError('Could not load products. Select the category again to retry.'); }
    finally { if (request === itemRequest.current) setLoading(false); }
  };
  const getSubCategoryProducts = event => {
    const selected = products.find(product => String(product.menuCatId) === event.target.value);
    setSelectedProduct(selected || null); setSearchTerm(''); setDropdownOpenId(null);
    if (selected) getSubCategoryProductsCustom(selected.menuCatId);
    else { ++itemRequest.current; setItems([]); }
  };

  const addNewCategory = async () => {

    const body =
    {
      "name": categoryName,
      "priority": priority,
      "business": {
        "restaurant_id": selectedBusiness
      }
    }

    var service = apiUrlService.PostApi(body)
    fetch(`${brand.apiBaseUrl}/menuCat`, service).then((response) => response.json())
      .then((response) => {
        setLoading(false)
        if (response.status === true) {
          toast.success("Category Created!");
          setAddModalOpen(false)
          getRestaurantMenuCustom(selectedBusiness)
          setCategoryName("")
          setPriority("")



        }
      })

  }


  useEffect(() => {
    const fetchUserRole = async () => {
      setLoading(true);
  
      try {
        const user = await AsyncStorage.getItem("myUser");
        if (user) {
          const parsedUser = JSON.parse(user);
          const { role, email } = parsedUser;
  
          setUserRole(role); // Set the role from AsyncStorage
          setPhoneNumber(email);
  
          if (role === 'ROLE_BUSINESS') {
           const response = await findBusinessByPhoneNumber(email)
           setCustomers([{label: response.data.data.name, value: response.data.data.restaurant_id}]);
           await getRestaurantMenuByBusiness(response.data.data.restaurant_id)
          } else if (role === 'ROLE_ADMIN') {
            await getMenu();
          }
        }
      } catch (error) {
        console.error("Error fetching user role:", error);
      } finally {
        setLoading(false);
      }
    };
  
  fetchUserRole();
      // Fetch businesses on component mount
  }, []);

  useEffect(() => {
    if (selectedProduct) {
      setCategoryName(selectedProduct.name || "");
      setPriority(selectedProduct.priority || "");
    }
  }, [selectedProduct]);

  useEffect(() => {
    if (selectedOrder) {
      setProductName(selectedOrder.name || "");
      setPrice(selectedOrder.price || "");
      setDescription(selectedOrder.description || "")
      setIsFeatured(selectedOrder.isFeatured || "")
      setDiscount(selectedOrder.discount || "")
      setDiscountPercentage(selectedOrder.discountPercentage || "");
      setStock(selectedOrder.stock || "");
      setBarcode(selectedOrder.barcode || "")
      setOutOfStock(selectedOrder.outOfStock || "")
      setProductImage(selectedOrder.image || "")
      setAddOns(selectedOrder.addOns || [])
      console.log(selectedOrder.image )
    }
  }, [selectedOrder]);

  const [addOns, setAddOns] = useState([]);

  // Update AddOn title
  const handleAddOnChange = (e, addOnIndex) => {
    const newAddOns = [...addOns];
    newAddOns[addOnIndex].title = e.target.value;
    setAddOns(newAddOns);
  };

// Add a new AddOn
const addAddOn = () => {
  setAddOns([...addOns, { title: '', addOnsItems: [{ name: '', price: '' }] }]);
};

// Add a new AddOnItem to a specific AddOn
const addAddOnItem = (addOnIndex) => {
  const newAddOns = [...addOns];
  newAddOns[addOnIndex].addOnsItems.push({ name: '', price: '' });
  setAddOns(newAddOns);
};

// Update AddOnItem fields
const handleAddOnItemChange = (e, addOnIndex, itemIndex, field) => {
  const newAddOns = [...addOns];
  newAddOns[addOnIndex].addOnsItems[itemIndex][field] = e.target.value;
  setAddOns(newAddOns);
};

// Remove an AddOn
const removeAddOn = (addOnIndex) => {
  const newAddOns = [...addOns];
  newAddOns.splice(addOnIndex, 1); // Remove the AddOn at the given index
  setAddOns(newAddOns);
};

// Remove an AddOnItem from a specific AddOn
const removeAddOnItem = (addOnIndex, itemIndex) => {
  const newAddOns = [...addOns];
  newAddOns[addOnIndex].addOnsItems.splice(itemIndex, 1); // Remove the item at the given index
  setAddOns(newAddOns);
};

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      const formData = new FormData();
      formData.append("file", file);
      try {
        const response = await axios.post(
          `${brand.apiBaseUrl}/saveImage`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        setLastImage(response.data.data)

      } catch (error) {
        console.error("Error uploading image:", error.message);
        toast.error("Failed to upload image.");
      }
    }
  };

  const handleCheckboxChange = (e) => {
    setIsFeatured(e.target.checked); // Updates state based on checkbox status
  };


  const handleOutOfStockChange = (e) => {
    setOutOfStock(e.target.checked); // Updates state based on checkbox status
  };

  const handleDiscountChange = (e) => {
    setDiscount(e.target.checked); // Updates state based on checkbox status
  };


  const handleProductImageChange = async (e) => {
 
    const file = e.target.files[0];
    if (file) {
      setProductImage(file);
      const formData = new FormData();
      formData.append("file", file);
      try {
        const response = await axios.post(
          `${brand.apiBaseUrl}/saveImage`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        setProductLastImage(response.data.data)
        setProductImage(response.data.data);
      } catch (error) {
        console.error("Error uploading image:", error.message);
        toast.error("Failed to upload image.");
      }
    }
  };

  const handleDeleteCategory = async () => {
    const response = await deleteMenuCategory(selectedProduct.menuCatId)
    if (response.status) {
      toast.success("Deleted");
      getRestaurantMenuCustom(selectedBusiness)
    } else {
      toast.error("Error!")
    }
  }

  const handleEditCategory = async () => {
    const response = await editMenuCategory(selectedProduct.menuCatId, categoryName, priority)
    if (response.status) {
      toast.success("Success")
      getRestaurantMenuCustom(selectedBusiness)
      setEditModalOpen(false)
    } else {
      toast.error("Error!")
    }
  }

  const handleAddProduct = async () => {


const body =
    {
      "name": productName,
      "price": price,
      "image": productLastImage,
      "stock": stock,
      "outOfStock": outOfStock,
      "discount": discount,
      "description": description,
      "barcode": barcode,
      "discountPercentage":discountPercentage,
      "isFeatured": isFeatured,
      "menuCategory": {
        "menuCatId": selectedProduct.menuCatId
      },
        // Ensure addOns is defined as an empty array if it's undefined
        "addOns": (addOns || [])
    

    }
    var service = apiUrlService.PostApi(body)
    fetch(`${brand.apiBaseUrl}/product`, service).then((response) => response.json())
      .then((response) => {
        if (response.status === true) {
          toast.success("Product Added")
          getSubCategoryProductsCustom(selectedProduct.menuCatId)
          setAddProductModalOpen(false)
          setProductName("")
          setPrice("")
          setProductLastImage(null)
          setImage(null)
          setLastImage(null)
          setProductImage(null)
          setOutOfStock(false)
          setIsFeatured(false)
          setDescription("")
          setDiscountPercentage("")
          setStock("")
          setBarcode("")
          setAddOns([])
          setDiscount(false)
        }
      })
 
  }

  const closeAddModal = () => {
    setAddProductModalOpen(false)
         
  }

  const handleDeleteProduct = async (id) => {
    toggleDropdown(null)
    const response = await deleteProduct(id);
    if (response.status) {
      
      toast.success("Deleted!")
      getSubCategoryProductsCustom(selectedProduct.menuCatId)
    } else {
      toast.error("Error")
    }

  }
  const handleOpenAddModal = () => {
    setProductImage(null)
    setProductName("")
    setPrice("")
    setProductLastImage(null)
    setOutOfStock(false)
    setIsFeatured(false)
    setDescription("")
    setDiscountPercentage("")
    setStock("")
    setBarcode("")
    setDiscount(false)
    setAddOns([])
    setAddProductModalOpen(true)
    console.log(productImage)
  }

  const handleEditProduct = async () => {
    console.log(JSON.stringify(addOns))

    const body =
    {
      "name": productName,
      "price": price,
      "image": productImage ? productImage : productLastImage,
      "outOfStock": outOfStock,
      "discount": discount,
      "stock": stock,
      "barcode": barcode,
      "description": description,
      "discountPercentage":discountPercentage,
      "isFeatured": isFeatured,
      "menuCategory": {
        "menuCatId": selectedProduct.menuCatId
      },
        // Ensure addOns is defined as an empty array if it's undefined
        "addOns": (addOns || [])
    

    }

    console.log(JSON.stringify(body))
 var service = apiUrlService.PutApi(body)
    fetch(`${brand.apiBaseUrl}/product/`+ selectedOrder.productId, service).then((response) => response.json())
      .then((response) => {
        if (response.status === true) {
          toast.success("Product Updated !")
          getSubCategoryProductsCustom(selectedProduct.menuCatId)
          setEditProductModal(false)
          setProductName("")
          setPrice("")
          setProductLastImage("")
          setOutOfStock(false)
          setIsFeatured(false)
          setDescription("")
          setDiscountPercentage("")
          setStock("")
          setBarcode("")
          setAddOns([])
          setDiscount(false)
        }
      })
 
  }

  const closeEditModal = () => {
    setEditProductModal(false)
   
  }

  return (
    <Layout>
      <div className="category-page menu-page">
      <ToastContainer />
      <header className="category-header"><p>{brand.displayName.toUpperCase()} / CATALOG</p><h1>Menu</h1><span>Choose a business and category to manage its products.</span></header>
      <div className="category-collection">
        <div className="menu-selectors">
          <label htmlFor="menu-business"><span>01 · Business</span><select id="menu-business" value={selectedBusiness || ''} onChange={getRestaurantMenu} disabled={userRole === 'ROLE_BUSINESS' || !customers.length}>
            {!customers.length && <option value="">{loading ? 'Loading businesses…' : 'No businesses available'}</option>}
            {customers.map(customer => <option key={customer.value} value={customer.value}>{customer.label}</option>)}
          </select></label>
          <label htmlFor="menu-category"><span>02 · Category</span><select id="menu-category" value={selectedProduct?.menuCatId || ''} onChange={getSubCategoryProducts} disabled={!products.length}>
            {!products.length && <option value="">{loading ? 'Loading categories…' : 'No categories available'}</option>}
            {products.map(product => <option key={product.menuCatId} value={product.menuCatId}>{product.name}</option>)}
          </select></label>
          <button className="menu-new-category" disabled={!selectedBusiness || loading} onClick={() => {setCategoryName(''); setPriority(''); setAddModalOpen(true);}}><PlusIcon />New Category</button>
        </div>
        {menuError && <div className="category-empty" role="alert">{menuError}</div>}
        {selectedBusiness && selectedProduct &&
          <div className="menu-category-title">
            <label>{selectedProduct.name}</label>
            <button
              className="flex border border-darkGrey items-center justify-center w-6 h-6  text-white rounded-lg hover:border-yellow transition"
              aria-label="Edit selected category"
              onClick={() => setEditModalOpen(true)}
            >
              <PencilIcon className="w-3 h-3 text-darkGrey hover:text-yellow " />
            </button>

            {/* Delete Button */}
            <button
              className="flex border border-darkGrey items-center justify-center w-6 h-6 text-white rounded-lg hover:border-yellow transition"
              aria-label="Delete selected category"
              onClick={() => handleDeleteCategory()}
            >
              <TrashIcon className="w-3 h-3 text-darkGrey hover:text-yellow  " />
            </button>
          </div>}

        {selectedBusiness && selectedProduct && <div className="data-toolbar bg-grey flex justify-between items-center mb-0 w-full border-t border-l pl-3 border-r pr-3 pt-3 border-gray-200">

          <div className="w-1/3 pb-3">
            <input
              type="text"
              value={searchTerm}
              onChange={handleSearchChange}
              placeholder="Search products…" aria-label="Search products"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="npb-3 flex">
            <button
              onClick={() => handleOpenAddModal()}
              className="mr-5 px-4 py-2 bg-yellow flex text-white font-inter text-sm font-sm rounded-lg hover:bg-customColor transition-colors"
            > <PlusIcon className="h-4 w-4 mr-2 mt-0.4" />
              New Product
            </button>

          </div>
        </div>}


        <div className="category-grid" aria-label="Menu products" aria-busy={loading}>
          {!loading && selectedProduct && filteredOrders.map(order => <article className="category-card" key={order.productId}>
            <button className="category-preview" onClick={() => openModal(order)} aria-label={`Edit ${order.name}`}><span className="category-fallback" aria-hidden="true">{order.name?.charAt(0).toUpperCase() || 'P'}</span>{order.image && <img key={order.image} src={order.image} alt="" loading="lazy" onError={event => {event.currentTarget.style.display='none';}} />}</button>
            {order.discount && <span className="menu-discount">{order.discountPercentage}% off</span>}
            <div className="category-info"><div><h2 title={order.name}>{order.name}</h2><span>{new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(Number(order.price) || 0)}{order.outOfStock ? ' · Out of stock' : ''}</span></div><button className="category-menu-toggle" aria-label={`Actions for ${order.name}`} aria-expanded={dropdownOpenId === order.productId} onClick={() => toggleDropdown(order.productId)}><EllipsisVerticalIcon /></button></div>
            {dropdownOpenId === order.productId && <div className="category-menu"><button onClick={() => openModal(order)}><PencilIcon />Edit product</button><button className="category-delete" onClick={() => {toggleDropdown(null); handleDeleteProduct(order.productId);}}><TrashIcon />Delete product</button></div>}
          </article>)}
        </div>
        {(loading || !filteredOrders.length || !selectedProduct) && !menuError && <div className="category-empty" role="status">{loading ? 'Loading menu…' : !selectedBusiness ? 'No businesses available.' : !selectedProduct ? 'No categories yet. Add a category to get started.' : searchTerm ? 'No products match your search.' : 'No products in this category yet.'}</div>}

        {/* Add Category Modal */}
        {addModalOpen && (
          <div className="menu-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="menu-modal-panel bg-white rounded-lg shadow-lg p-6 w-96">
              <h3 className="text-lg font-semibold mb-4">Add Category</h3>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Category Name</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  placeholder='Category Name'
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Priority</label>
                <input
                  type="number"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                  //value={newQuantity}
                  placeholder='Priority'
                  value={priority}
                  onChange={(e) => setPriority(e.target.value)}
                //onChange={(e) => setNewQuantity(e.target.value)}
                />
              </div>
              
              <div className="flex justify-end space-x-2 mt-4">
                <button
                  className="px-4 py-2 bg-gray-300 rounded-lg"
                  onClick={() => setAddModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  className="px-4 py-2 bg-gray-300 rounded-lg"
                  onClick={() => addNewCategory()}
                //onClick={() => handleSaveQuantity(selectedOrder.customer.customerId)}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Edit Category Modal */}
        {editModalOpen && (
          <div className="menu-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="menu-modal-panel bg-white rounded-lg shadow-lg p-6 w-96">
              <h3 className="text-lg font-semibold mb-4">Edit Category</h3>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Category Name</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  placeholder='Category Name'
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Priority</label>
                <input
                  type="number"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                  //value={newQuantity}
                  placeholder='Priority'
                  value={priority}
                  onChange={(e) => setPriority(e.target.value)}
                //onChange={(e) => setNewQuantity(e.target.value)}
                />
              </div>
             
              <div className="flex justify-end space-x-2 mt-4">
                <button
                  className="px-4 py-2 bg-gray-300 rounded-lg"
                  onClick={() => setEditModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  className="px-4 py-2 bg-gray-300 rounded-lg"
                  onClick={() => handleEditCategory()}
                //onClick={() => handleSaveQuantity(selectedOrder.customer.customerId)}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}

    {/* Add Product Modal */}
{addProductModalOpen && (
  <div className="menu-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div className="menu-modal-panel bg-white rounded-lg shadow-lg p-6 w-96">
      <h3 className="text-lg font-semibold mb-4">Add Product</h3>

      <div className="modal-content" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
        {/* Product Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Product Name</label>
          <input
            type="text"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
            placeholder='Product Name'
            value={productName}
            onChange={(e) => setProductName(e.target.value)}
          />
        </div>

        {/* Price */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Price</label>
          <input
            type="number"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            placeholder='Price'
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
        </div>

        {/* Description */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Descirption</label>
          <textarea
            className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
            placeholder='Description'
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>

        <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Product Image
                </label>
                <input
                  type="file"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  accept="image/*"
                  onChange={handleProductImageChange}
                />

        

                {productImage && (
                  <div className="mt-2">
                    <img
                      src={productLastImage ? productLastImage : URL.createObjectURL(productImage)}
                      alt="Selected Category"
                      className="w-32 h-32 object-cover rounded"
                    />
                  </div>
                )}
              </div>
              <div className=" mt-2">
                
                <label className="block text-sm font-medium text-gray-700 mb-1 w-1/3">Stock</label>
                <input
                 type="text"
                 className="w-1/2 px-1 py-1 border border-gray-300 rounded-lg mb-1 mt-1"
                 placeholder='Stock'
                 value={stock}
                 onChange={(e) => setStock(e.target.value)}
               />
              </div>
              <div className=" mt-2">
                
                <label className="block text-sm font-medium text-gray-700 mb-1 w-1/3">Barcode No.</label>
                <input
                 type="text"
                 className="w-1/2 px-1 py-1 border border-gray-300 rounded-lg mb-1 mt-1"
                 placeholder='Barcode'
                 value={barcode}
                 onChange={(e) => setBarcode(e.target.value)}
               />
              </div>
            

              <div className="flex mt-2">
                
                <label className="block text-sm font-medium text-gray-700 mb-1 w-1/3">Is Featured?</label>
                <input
                  type="checkbox"
                  checked={isFeatured} // Controlled by state
                  onChange={handleCheckboxChange} // Update state on change
                  className="h-4 w-4 text-blue-600 border-gray-300 rounded w-1/3"
                />
              </div>
              <div className="flex">
                <label className="block text-sm font-medium text-gray-700 mb-1 w-1/3">Out of stock?</label>
                <input
                  type="checkbox"
                  checked={outOfStock} // Controlled by state
                  onChange={handleOutOfStockChange} // Update state on change
                  className="h-4 w-4 text-blue-600 border-gray-300 rounded w-1/3"
                />
              </div>
              <div className="flex">
                <label className="block text-sm font-medium text-gray-700 mb-1 w-1/3">Discount?</label>
                <input
                  type="checkbox"
                  checked={discount}
                  onChange={handleDiscountChange}
                  className="h-4 p-2 ml-2  w-4 text-blue-600 border-gray-300 rounded w-1/3"
                />
              </div>
              {discount && <div>
               
               <input
                 type="text"
                 className="w-1/2 px-1 py-1 border border-gray-300 rounded-lg mb-1 mt-1"
                 placeholder='Percentage'
                 value={discountPercentage}
                 onChange={(e) => setDiscountPercentage(e.target.value)}
               />
             </div>}

        {/* AddOns Section */}
<h4 className="text-sm font-semibold mt-4">AddOns</h4>
{addOns && addOns.map((addOn, addOnIndex) => (
  <div key={addOnIndex} className="mb-4 border rounded p-3">
    <div className="flex justify-between items-center mb-2">
      <label className="block text-sm font-medium text-gray-700">Title</label>
      <button
        className="text-red-500 text-sm"
        onClick={() => removeAddOn(addOnIndex)}
      >
        <MinusCircleIcon className="w-7 h-7 text-darkGrey hover:text-yellow" />
      </button>
    </div>
    <input
      type="text"
      placeholder="Title"
      className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-2"
      value={addOn.title}
      onChange={(e) => handleAddOnChange(e, addOnIndex)}
    />

    {/* AddOnsItems for this AddOn */}
    <div>
      <h5 className="text-sm font-semibold">AddOns Items</h5>
      {addOn.addOnsItems.map((item, itemIndex) => (
        <div key={itemIndex} className="flex gap-2 mt-2 items-center">
          <input
            type="text"
            placeholder="Name"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            value={item.name}
            onChange={(e) => handleAddOnItemChange(e, addOnIndex, itemIndex, 'name')}
          />
          <input
            type="number"
            placeholder="Price"
            className="w-24 px-3 py-2 border border-gray-300 rounded-lg"
            value={item.price}
            onChange={(e) => handleAddOnItemChange(e, addOnIndex, itemIndex, 'price')}
          />
          <button
            className="text-red-500 text-sm"
            onClick={() => removeAddOnItem(addOnIndex, itemIndex)}
          >
            <MinusCircleIcon className="w-5 h-5 text-darkGrey hover:text-yellow" />
          </button>
        </div>
      ))}
    </div>
    <button
      className="flex text-gray-700 text-sm mt-2 hover:text-yellow"
      onClick={() => addAddOnItem(addOnIndex)}
    >
      <PlusCircleIcon className="w-5 h-5 text-darkGrey hover:text-yellow" /> Add Item
    </button>
  </div>
))}
<button
   className="flex text-gray-700 text-sm mt-2 hover:text-yellow"
  onClick={addAddOn}
>
<PlusCircleIcon className="w-5 h-5 text-darkGrey hover:text-yellow" /> Add New AddOn
</button>


      </div>

      <div className="flex justify-end space-x-2 mt-4">
        <button
          className="px-4 py-2 bg-gray-300 rounded-lg"
          onClick={() => closeAddModal()}
        >
          Cancel
        </button>
        <button
          className="px-4 py-2 bg-gray-300 rounded-lg"
          onClick={() => handleAddProduct()}
        >
          Save
        </button>
      </div>
    </div>
  </div>
)}



           {/* Edit Product Modal */}
           {editProductModal && (
           <div className="menu-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
             <div className="menu-modal-panel bg-white rounded-lg shadow-lg p-6 w-11/12 sm:w-96 max-h-[90vh] overflow-y-auto">
              <h3 className="text-lg font-semibold mb-4">Edit Product</h3>
              <div className="modal-content" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                <label className="block text-sm font-medium text-gray-700 mb-1">Product Name</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  placeholder='Product Name'
                  value={productName}
                  onChange={(e) => setProductName(e.target.value)}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Price</label>
                <input
                  type="number"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                  //value={newQuantity}
                  placeholder='Price'
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                //onChange={(e) => setNewQuantity(e.target.value)}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Descirption</label>
                <textarea
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  placeholder='Descirption'
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Product Image
                </label>
                <input
                  type="file"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  accept="image/*"
                  onChange={handleProductImageChange}
                />

              

     

        {productImage &&  (
                  <div className="mt-2">
                    <img
                      src={productImage}
                      alt="Selected Category"
                      className="w-32 h-32 object-cover rounded"
                    />
                  </div>
                )}
              </div>
              <div className=" mt-2">
                
                <label className="block text-sm font-medium text-gray-700 mb-1 w-1/3">Stock</label>
                <input
                 type="text"
                 className="w-1/2 px-1 py-1 border border-gray-300 rounded-lg mb-1 mt-1"
                 placeholder='Stock'
                 value={stock}
                 onChange={(e) => setStock(e.target.value)}
               />
              </div>
              <div className=" mt-2">
                
                <label className="block text-sm font-medium text-gray-700 mb-1 w-1/3">Barcode No.</label>
                <input
                 type="text"
                 className="w-1/2 px-1 py-1 border border-gray-300 rounded-lg mb-1 mt-1"
                 placeholder='Barcode'
                 value={barcode}
                 onChange={(e) => setBarcode(e.target.value)}
               />
              </div>
              <div className="flex justify-between items-center mt-5">
  <label className="block text-sm font-medium text-gray-700 mb-1 w-1/3">Is Featured?</label>
  <input
    type="checkbox"
    checked={isFeatured} // Controlled by state
    onChange={handleCheckboxChange} // Update state on change
    className="h-4 w-4 text-blue-600 border-gray-300 rounded mr-10"
  />
</div>

<div className="flex justify-between items-center">
  <label className="block text-sm font-medium text-gray-700 mb-1 w-1/3">Out of stock?</label>
  <input
    type="checkbox"
    checked={outOfStock} // Controlled by state
    onChange={handleOutOfStockChange} // Update state on change
    className="h-4 w-4 text-blue-600 border-gray-300 rounded mr-10"
  />
</div>

<div className="flex justify-between items-center">
  <label className="block text-sm font-medium text-gray-700 mb-1 w-2/3">Discount?</label>
  <input
    type="checkbox"
    checked={discount}
    onChange={handleDiscountChange}
    className="h-4 w-4 text-blue-600 border-gray-300 rounded mr-10"
  />
</div>

              {discount && <div className="mb-4">
               
               <input
                 type="text"
                 className="w-1/2 px-1 py-1 border border-gray-300 rounded-lg mb-1 mt-1"
                 placeholder='Percentage'
                 value={discountPercentage}
                 onChange={(e) => setDiscountPercentage(e.target.value)}
               />
             </div>}
             
       {/* Add-On Section */}
       <div className="mt-4">
        <h4 className="text-sm font-semibold mb-2">Add-Ons</h4>
        {addOns.map((addOn, addOnIndex) => (
          <div key={addOnIndex} className="mb-4">
            <div className="flex justify-between items-center mb-2">
              <input
                type="text"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                placeholder="Add-On Title"
                value={addOn.title}
                onChange={(e) => handleAddOnChange(e, addOnIndex)}
              />
              <button
                onClick={() => removeAddOn(addOnIndex)}
                className="text-red-500 ml-2"
              >
               <MinusCircleIcon className="w-7 h-7 text-darkGrey hover:text-yellow" />
              </button>
            </div>

            {/* Add-On Items */}
            {addOn.addOnsItems.map((item, itemIndex) => (
              <div key={itemIndex} className="flex space-x-4 mb-2">
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                  placeholder="Item Name"
                  value={item.name}
                  onChange={(e) => handleAddOnItemChange(e, addOnIndex, itemIndex, 'name')}
                />
                <input
                  type="number"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                  placeholder="Item Price"
                  value={item.price}
                  onChange={(e) => handleAddOnItemChange(e, addOnIndex, itemIndex, 'price')}
                />
                <button
                  onClick={() => removeAddOnItem(addOnIndex, itemIndex)}
                  className="text-red-500"
                >
                   <MinusCircleIcon className="w-5 h-5 text-darkGrey hover:text-yellow" />
                </button>
              </div>
            ))}
            <button
      className="flex text-gray-700 text-sm mt-2 hover:text-yellow"
      onClick={() => addAddOnItem(addOnIndex)}
    >
      <PlusCircleIcon className="w-5 h-5 text-darkGrey hover:text-yellow" /> Add Item
    </button>
          </div>
        ))}
        <button
          onClick={addAddOn}
          className="px-4 py-2 bg-yellow text-white rounded-lg"
        >
          Add New Add-On
        </button>
      </div>
              <div className="flex justify-end space-x-2 mt-4">
                <button
                  className="px-4 py-2 bg-gray-300 rounded-lg"
                  onClick={() => closeEditModal()}
                >
                  Cancel
                </button>
                <button
                  className="px-4 py-2 bg-gray-300 rounded-lg"
                  onClick={() => handleEditProduct()}
                //onClick={() => handleSaveQuantity(selectedOrder.customer.customerId)}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}



      </div>
    </div>
    </Layout>
  );
};

export default Products;
